import LoginWith42Macro from "auth/loginWith42Macro/LoginWith42Macro";
import { useUserDataQuery } from "../../_shared/graphql";
import { useEffect, useState } from "react";
import { API } from "aws-amplify";

export default function Integrations() {
  const { data } = useUserDataQuery();
  const [verified, setVerified] = useState(false);
  useEffect(() => {
    setVerified(data?.users?.[0]?.verified_42macro ? true : false);
  }, [data]);

  if (!data) return null;
  return verified ? (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          backgroundColor: "#171717",
          width: "100%",
          maxWidth: 1000,
          padding: 30,
          borderRadius: 7,
          color: "#fff",
        }}
      >
        <div style={{ width: "100%", maxWidth: 550 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              fontSize: 22,
            }}
          >
            Congrats, you're verified with{" "}
            <img
              style={{
                height: 40,
                width: 40,
                marginTop: -3,
                marginLeft: 10,
                marginRight: 5,
              }}
              src={"/42macro_tabs.svg"}
            />
            Macro
          </div>
          <div style={{ marginTop: 10 }}>
            • As long as you maintain your{" "}
            <span style={{ fontWeight: 800, color: "#458bff" }}>
              42 Macro Bundle
            </span>{" "}
            or{" "}
            <span style={{ fontWeight: 800, color: "#458bff" }}>
              Around the Horn Weekly
            </span>{" "}
            subscription, you will keep complimentary access to the{" "}
            <span style={{ fontWeight: 800, color: "#75ce41" }}>
              Longbow Pro
            </span>{" "}
            plan
          </div>
          <div style={{ marginTop: 10 }}>
            • If you cancel your{" "}
            <span style={{ fontWeight: 800, color: "#458bff" }}>
              42 Macro subscription
            </span>{" "}
            or upgrade to another Longbow plan, you will lose access to the
            complimentary{" "}
            <span style={{ fontWeight: 800, color: "#75ce41" }}>
              Longbow Plus
            </span>{" "}
            plan at the start of your next billing cycle
          </div>
          <div style={{ textAlign: "center", marginTop: 40 }}>
            <a
              onClick={async () => {
                if (
                  confirm(
                    "Are you sure you want to disconnect your 42 Macro account?",
                  )
                ) {
                  await API.post("auth", "/cognito/disconnect42Macro", {});
                  setVerified(false);
                }
              }}
              style={{ color: "#75ce41", textDecorationLine: "none" }}
              href="#"
            >
              Disconnect my 42 Macro account
            </a>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div style={{ marginTop: -150 }}>
      <LoginWith42Macro
        setVerified={setVerified}
        userId={data?.users?.[0]?.id}
      />
    </div>
  );
}
